import { SupabaseServiceView } from "../../../server/supabase/base-supabase-service";

export class SupabasePersonConflictService extends SupabaseServiceView<"person_conflicts_in_last_sync"> {
  table = "person_conflicts_in_last_sync" as const;
}
